import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import SearchBar from './components/SearchBar';
import Filters from './components/Filters';
import CareerList from './components/CareerList';
import TestVocacional from './components/TestVocacional';
import Footer from './components/Footer';
import carrerasData from './data/carreras.json';
import bannerTest from './assets/test.jpeg';
import bannerAsuntos from './assets/asuntos.jpeg';
import bannerDeportes from './assets/deportes.jpg';

function App() {
  // Filtrar inicialmente solo a UNLZ (tipo: Pública, provincia: Buenos Aires)
  const unlzCarreras = carrerasData.filter(carrera =>
    carrera.universidad.includes("Universidad Nacional de Lomas de Zamora") &&
    carrera.tipo === "Pública" &&
    carrera.provincia === "Buenos Aires"
  );

  const carreras = unlzCarreras;
  const [filteredCarreras, setFilteredCarreras] = useState(unlzCarreras);
  const [searchQuery, setSearchQuery] = useState('');
  const [modalidadFilter, setModalidadFilter] = useState('');
  const [tituloFilter, setTituloFilter] = useState('');
  const [facultadFilter, setFacultadFilter] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const [showAllCareers, setShowAllCareers] = useState(false);
  const [showTest, setShowTest] = useState(false);

  useEffect(() => {
    if (showAllCareers) {
      setFilteredCarreras(carreras);
      return;
    }
    let filtered = carreras;

    if (searchQuery) {
      filtered = filtered.filter(carrera =>
        carrera.nombre.toLowerCase().includes(searchQuery.toLowerCase()) ||
        carrera.universidad.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    if (modalidadFilter) {
      filtered = filtered.filter(carrera => carrera.modalidad === modalidadFilter);
    }

    if (tituloFilter) {
      filtered = filtered.filter(carrera => carrera["título obtenido"].toLowerCase().includes(tituloFilter.toLowerCase()));
    }

    if (facultadFilter) {
      filtered = filtered.filter(carrera => carrera.facultad === facultadFilter);
    }

    setFilteredCarreras([...new Set(filtered.map(c => c.id))].map(id => filtered.find(c => c.id === id)));
  }, [searchQuery, modalidadFilter, tituloFilter, facultadFilter, carreras, showAllCareers]);

  const modalidades = [...new Set(carreras.map(c => c.modalidad))];
  const facultades = [...new Set(carreras.map(c => c.facultad))];

  return (
    <div className="min-h-screen flex flex-col bg-slate-50 font-sans text-slate-800">
      <Header />

      <main className="flex-grow container mx-auto px-4 py-8 max-w-6xl space-y-12">
        {/* Sección de Búsqueda */}
        <div className="flex flex-col items-center space-y-6">
          <div className="w-full max-w-3xl bg-white p-6 rounded-2xl shadow-card hover:shadow-card-hover transition-shadow duration-300 relative z-50">
            <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />

            <div className="flex justify-center mt-6 space-x-4">
              <button
                onClick={() => setActiveTab(0)}
                className={`px-6 py-2 rounded-full font-semibold transition-all duration-200 ${activeTab === 0
                  ? 'bg-primary-600 text-white shadow-md transform scale-105'
                  : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                  }`}
              >
                Búsqueda Básica
              </button>
              <button
                onClick={() => setActiveTab(1)}
                className={`px-6 py-2 rounded-full font-semibold transition-all duration-200 ${activeTab === 1
                  ? 'bg-primary-600 text-white shadow-md transform scale-105'
                  : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                  }`}
              >
                Filtros Avanzados
              </button>
            </div>

            {/* Filtros Avanzados */}
            <div className={`overflow-hidden transition-all duration-500 ease-in-out ${activeTab === 1 ? 'max-h-96 opacity-100 mt-6' : 'max-h-0 opacity-0'}`}>
              <Filters
                modalidades={modalidades}
                facultades={facultades}
                modalidadFilter={modalidadFilter}
                setModalidadFilter={setModalidadFilter}
                tituloFilter={tituloFilter}
                setTituloFilter={setTituloFilter}
                facultadFilter={facultadFilter}
                setFacultadFilter={setFacultadFilter}
              />
            </div>
          </div>
        </div>

        {/* Lista de Carreras */}
        <div>
          {filteredCarreras.length === 0 && searchQuery ? (
            <div className="text-center py-12">
              <p className="text-xl text-slate-500 font-medium">Lo sentimos, no encontramos carreras que coincidan con tu búsqueda.</p>
            </div>
          ) : (
            (searchQuery || modalidadFilter || tituloFilter || facultadFilter || showAllCareers) && (
              <CareerList carreras={filteredCarreras} groupByFaculty={showAllCareers} />
            )
          )}
        </div>

        {/* Botón Ver Todo */}
        {!showAllCareers && (
          <div className="text-center">
            <button
              onClick={() => setShowAllCareers(true)}
              className="px-8 py-3 bg-white border-2 border-primary-600 text-primary-600 font-bold rounded-full hover:bg-primary-50 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
            >
              VER TODA LA OFERTA ACADÉMICA
            </button>
          </div>
        )}
        {showAllCareers && (
          <div className="text-center">
            <button
              onClick={() => setShowAllCareers(false)}
              className="px-8 py-3 bg-white border-2 border-slate-400 text-slate-600 font-bold rounded-full hover:bg-slate-50 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
            >
              OCULTAR OFERTA ACADÉMICA
            </button>
          </div>
        )}


        {/* Sección de Banners Informativos */}
        <section className="flex flex-col gap-8">
          {!showTest ? (
            <div className="relative h-64 rounded-2xl overflow-hidden shadow-card group cursor-pointer" onClick={() => setShowTest(true)}>
              <div className="absolute inset-0 bg-gradient-to-r from-primary-900/90 to-primary-600/80 z-10 transition-opacity duration-300 group-hover:opacity-95"></div>
              {/* PENDIENTE: El usuario proveerá la imagen. Reemplazar la URL abajo. */}
              <div className="absolute inset-0 bg-slate-800 bg-cover bg-center" style={{ backgroundImage: `url(${bannerTest})` }}></div>
              <div className="relative z-20 flex flex-col justify-center h-full p-8 text-white">
                <h3 className="text-3xl font-bold mb-2">¿Aún no te decidiste?</h3>
                <p className="text-slate-100 mb-4">¿Indeciso? Descubre tu camino ideal con nuestro test interactivo.</p>
                <span className="inline-block w-max px-4 py-2 border-2 border-white rounded-full text-sm font-semibold group-hover:bg-white group-hover:text-primary-700 transition-colors">Comenzar Test</span>
              </div>
            </div>
          ) : (
            <div className="col-span-2 bg-white rounded-2xl shadow-card p-6">
              <button onClick={() => setShowTest(false)} className="mb-4 text-sm text-slate-500 hover:text-primary-600 flex items-center">
                ← Volver
              </button>
              <TestVocacional onBack={() => setShowTest(false)} />
            </div>
          )}

          {!showTest && (
            <>
              <div className="relative h-64 rounded-2xl overflow-hidden shadow-card group cursor-pointer" onClick={() => window.open('https://www.unlz.edu.ar/?page_id=2672', '_blank')}>
                <div className="absolute inset-0 bg-gradient-to-r from-accent-500/90 to-orange-400/80 z-10 transition-opacity duration-300 group-hover:opacity-95"></div>
                {/* PENDIENTE: Reemplazar imagen de Asuntos Estudiantiles aquí */}
                <div className="absolute inset-0 bg-slate-800 bg-cover bg-center" style={{ backgroundImage: `url(${bannerAsuntos})` }}></div>
                <div className="relative z-20 flex flex-col justify-center h-full p-8 text-white">
                  <h3 className="text-3xl font-bold mb-2">Asuntos Estudiantiles</h3>
                  <p className="text-slate-100 mb-4">Becas, salud y servicios para acompañarte en tu carrera.</p>
                  <span className="inline-block w-max px-4 py-2 border-2 border-white rounded-full text-sm font-semibold group-hover:bg-white group-hover:text-accent-500 transition-colors">Más Información</span>
                </div>
              </div>

              <div className="relative h-64 rounded-2xl overflow-hidden shadow-card group cursor-pointer" onClick={() => window.open('https://www.unlz.edu.ar/?page_id=2432', '_blank')}>
                <div className="absolute inset-0 bg-gradient-to-r from-green-600/90 to-emerald-400/80 z-10 transition-opacity duration-300 group-hover:opacity-95"></div>
                {/* PENDIENTE: Reemplazar imagen de Deportes aquí */}
                <div className="absolute inset-0 bg-slate-800 bg-cover bg-center" style={{ backgroundImage: `url(${bannerDeportes})` }}></div>
                <div className="relative z-20 flex flex-col justify-center h-full p-8 text-white">
                  <h3 className="text-3xl font-bold mb-2">Deportes UNLZ</h3>
                  <p className="text-slate-100 mb-4">Sumate a nuestros equipos y actividades recreativas.</p>
                  <span className="inline-block w-max px-4 py-2 border-2 border-white rounded-full text-sm font-semibold group-hover:bg-white group-hover:text-green-600 transition-colors">Ver Deportes</span>
                </div>
              </div>
            </>
          )}
        </section>

        {/* Video Section */}
        <section className="rounded-2xl overflow-hidden shadow-card-hover">
          <iframe
            className="w-full h-[400px] md:h-[500px]"
            src="https://www.youtube.com/embed/MAxYr4d4yfA"
            title="Video UNLZ"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </section>

      </main>

      <Footer />
    </div>
  );
}

export default App;